import { render } from "./TraitementResiliation.vue?vue&type=template&id=a6cc123c&ts=true"
import script from "./TraitementResiliation.vue?vue&type=script&lang=ts"
export * from "./TraitementResiliation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__